import { useLeaData } from "@/queries.ts";

type LeaData = ReturnType<typeof useLeaData>["data"];

/**
 * Look up a classroom's display name by (preschoolCode, programYear, localClassroomId).
 *
 * Returns an empty string if any input is missing, leaData hasn't loaded, or
 * no classroom matches. Safe to call before leaData resolves.
 */
export function getClassroomName(
  leaData: LeaData,
  preschoolCode?: string,
  programYear?: string,
  localClassroomId?: string
): string {
  if (
    !leaData?.entities?.classrooms ||
    !preschoolCode ||
    !programYear ||
    !localClassroomId
  )
    return "";
  const match = Object.values(leaData.entities.classrooms).find((c) => {
    const r = c.records[0];
    return (
      r?.PreschoolCode === preschoolCode &&
      r?.ProgramYear === programYear &&
      r?.LocalClassroomId === localClassroomId
    );
  });
  return match?.records?.[0]?.ClassroomName ?? "";
}
